module.exports = __webpack_public_path__ + "img/img1.695b2978.gif";